import * as React from 'react';
export const IcPlaneArrival = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.25 15.16l-2.77-1.38-2.07-7.06a1 1 0 00-.52-.61l-2-1a1 1 0 00-1.44.95l.27 4.85-2.51-1.26-.16-2.89a1 1 0 00-.56-.84l-2-1a1 1 0 00-.91 0 1 1 0 00-.52.74l-.48 3.39a3 3 0 00.57 2.23l.1.13c.58.78 1.338 1.41 2.21 1.84l11.11 5.54a2.001 2.001 0 002.76-1.09 2.07 2.07 0 00-1.08-2.54z'
      fill='currentColor'
    />
  </svg>
);
